export class AdBanner {
  public small: string;
  public large: string;
  public action: string;
  public destination: string;
  public param: string;

  constructor(small: string, large: string, action: string, destination: string, param: string) {
    this.small = small;
    this.large = large;
    this.action = action;
    this.destination = destination;
    this.param = param;
  }
}



// WEBPACK FOOTER //
// ./src/model/AdBanner.ts